<template>
  <div>
    <div
      id="edit_ai_settings_root"
      class="w-full h-full"
    />
  </div>
</template>

<script setup>
import { nextTick, onBeforeUnmount, onMounted } from 'vue';
import Tools from '~/Tools';
import CanvasTools from '~/view/CanvasTools';
import EditAISettings_canvas from '../canvas/edit_ai_settings/EditAISettings';

let _canvas_root;

onMounted(() => {
  nextTick(renderCanvas);
  window.addEventListener('resize', handleResize);
  window.addEventListener('orientationchange', handleResize);
});

onBeforeUnmount(() => {
  _canvas_root?.dispose();
  _canvas_root = null;
  window.removeEventListener('resize', handleResize);
  window.removeEventListener('orientationchange', handleResize);
});

function renderCanvas() {
  _canvas_root?.dispose();
  _canvas_root = new EditAISettings_canvas();
  const { x, y, height } = CanvasTools.getDomAnchor('edit_ai_settings_root');
  _canvas_root.x = x;
  _canvas_root.y = y - height * 0.2;
  // _canvas_root.transitionIn(0.2);
  DT_CANVAS_GLOBALS.stage.addChild(_canvas_root);
}

const handleResize = Tools.debounce(renderCanvas, 300);
</script>
